import React from "react";
import { Preview } from "./styles";

const FormatPicker = ({ value, setValue }) => (
  <div
    role="none"
    style={{
      position: "relative",
      marginBottom: "4px",
      display: "grid",
      placeSelf: "flex-end",
      placeItems: "flex-end",
    }}
    onClick={() => {
      if (value === "HH:mm") {
        setValue("hh:mm A");
      } else {
        setValue("HH:mm");
      }
    }}
  >
    <Preview>{value === "HH:mm" ? "24 h" : "12 h"}</Preview>
  </div>
);

export default FormatPicker;
